import { useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import verify_img from "../../images/verify_img.png";
import emailVerificationIcon from "../../images/emailVerificationIcon.png";
import { RootState } from '../store';
import { useDispatch, useSelector } from 'react-redux';
import { setResetPasswordWizardPageNumber } from '../ResetPasswordReducer';
import { setwizardPageNumber } from '../EntityAccountReducer';
import { useTranslation } from 'react-i18next';

type MyComponentProps = {
    videoConstraints?: any;
    show: boolean;
    handleClose: () => void;
    title: string;
};

const SuccessOTPModal = (props: MyComponentProps) => {
    const { t } = useTranslation();
    const [validated, setValidated] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const theme = useSelector((state: RootState) => state.theme.theme);

    const page = useSelector((state: RootState) => state.resetPassword.wizardPageNumber);
    const entityWizardPage = useSelector((state: RootState) => state.entityAccount.wizardPageNumber);

    const next = async (event: any) => {
        event.preventDefault();
        dispatch(setResetPasswordWizardPageNumber(page + 1));
    };

    const nextEntityWizardPage = async (event: any) => {
        event.preventDefault();
        dispatch(setwizardPageNumber(entityWizardPage + 1));
    };

    const backToLogin = async (event: any) => {
        event.preventDefault();
        navigate('/onboardingLoginAccount');
    };

    return (
        <Modal show={props.show} onHide={props.handleClose}>
            <Modal.Body className={`p-3 ${theme === 'dark' ? 'dark-modal' : ''}`}>
                <Form noValidate validated={validated}>
                    <div className="row mt-2 text-center d-flex flex-column align-items-center">
                        <div>
                            {props.title === "Verification Completed" ? (
                                <img className="w-25 mb-1" src={emailVerificationIcon} alt="Email Verification Icon" />
                            ) : (
                                <img className="w-25 mb-1" src={verify_img} alt="Verification" />
                            )}
                        </div>
                        <label className="mb-1 mt-3">{props.title}</label>

                        {props.title === "Reset Password Completed" ? (
                            <button
                                className="btn btn-dark mb-2 rounded-5 w-50 mt-3"
                                onClick={backToLogin}
                            >
                                {t('camera.back_to_login')}
                            </button>
                        ) : props.title === "Verification Completed" ? (
                            <button
                                className="btn btn-dark mb-2 rounded-5 w-50 mt-3"
                                onClick={nextEntityWizardPage}
                            >
                                {t('common.continue')}
                            </button>
                        ) : (
                            <button
                                className="btn btn-dark mb-2 rounded-5 w-50 mt-3"
                                onClick={next}
                            >
                                {t('common.continue')}
                            </button>
                        )}
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default SuccessOTPModal;
